export default "__VITE_ASSET__DCtCVsRV__"